<template>
    <div id="sidebar-menu">

        <ul class="sidebar-links custom-scrollbar" id="myDIV"
            :style="[layoutobject.split(' ').includes('horizontal-wrapper') ? layout.settings.layout_type == 'rtl' ? { '  -right': margin + 'px' } : { 'margin-left': margin + 'px' } : { margin: '0px' }]">
            <li class="back-btn">
                <router-link to="/">
                    <img class="img-fluid" src="../../assets/images/logo/logo.png" alt="" /></router-link>
                <div class="mobile-back text-end">
                    <span>Back</span><i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
                </div>
            </li>
            <li class="pin-title sidebar-main-title " :class="showPinTitle ? 'show' : ''">
                <div>
                    <h6>Pinned</h6>
                </div>
            </li>
            <li v-for="(menuItem, index) in menuItems" :key="index" class="sidebar-list"
                :class="{ ' sidebar-main-title': menuItem.type == 'headtitle', }, menuItem.showPin ? 'pined' : ''">
                <div v-if="menuItem.type == 'headtitle'">
                    <h6 class="lan-1">{{ (menuItem.headTitle1) }}</h6>
                </div>

                <!-- <i v-if="menuItem.type != 'headtitle'" class="fa fa-thumb-tack"
                    @click="togglePinnedName({ item: menuItem })"></i> -->
                <label :class="'badge badge-' + menuItem.badgeType" v-if="menuItem.badgeType">{{ (menuItem.badgeValue)
                }}</label>
                <a href="javascript:void(0)" class="sidebar-link sidebar-title" :class="{ 'active': menuItem.active }"
                    v-if="menuItem.type == 'sub'" @click="setNavActive(menuItem, index)">

                    <svg class="stroke-icon">
                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${menuItem.icon}`"></use>
                    </svg>
                    <svg class="fill-icon">
                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${menuItem.iconf}`"></use>
                    </svg>
                    <span class="lan-3">
                        {{ $t(menuItem.title) }}
                    </span>
                    <div class="according-menu" v-if="menuItem.children">
                        <i class="fa fa-angle-right pull-right"></i>
                    </div>
                </a>

                <router-link :to="menuItem.path" class="sidebar-link sidebar-title" v-if="menuItem.type == 'link'"
                    :class="{ 'active': menuItem.active }" v-on:click="hidesecondmenu()"
                    @click="setNavActive(menuItem, index)">
                    <svg class="stroke-icon">
                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${menuItem.icon}`"></use>
                    </svg>
                    <svg class="fill-icon">
                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${menuItem.iconf}`"></use>
                    </svg>
                    <span>
                        {{ $t(menuItem.title) }}
                    </span>
                    <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
                </router-link>

                <a :href="menuItem.path" class="sidebar-link sidebar-title" v-if="menuItem.type == 'extLink'"
                    @click="setNavActive(menuItem, index)">
                    <svg class="stroke-icon">
                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${menuItem.icon}`"></use>
                    </svg>
                    <svg class="fill-icon">
                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${menuItem.iconf}`"></use>
                    </svg>
                    <span>
                        {{ (menuItem.title) }}
                    </span>
                    <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
                </a>

                <a :href="menuItem.path" target="_blank" class="sidebar-link sidebar-title"
                    v-if="menuItem.type == 'extTabLink'" @click="setNavActive(menuItem, index)">
                    <svg class="stroke-icon">
                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${menuItem.icon}`"></use>
                    </svg>
                    <svg class="fill-icon">
                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${menuItem.iconf}`"></use>
                    </svg>
                    <span>
                        {{ (menuItem.title) }}
                    </span>
                    <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
                </a>

                <ul class="sidebar-submenu" v-if="menuItem.children" :class="{ 'menu-open': menuItem.active }"
                    :style="{ display: menuItem.active ? '' : 'none' }">

                    <li v-for="(childrenItem, index) in menuItem.children" :key="index">

                        <a class="lan-4" :class="{ 'active': childrenItem.active }" href="javascript:void(0)"
                            v-if="childrenItem.type == 'sub'" @click="setNavActive(childrenItem, index)">
                            {{ (childrenItem.title) }}
                            <label :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                                v-if="childrenItem.badgeType">{{ childrenItem.badgeValue }}</label>
                            <i class="fa pull-right mt-1"
                                v-bind:class="[childrenItem.active ? 'fa fa-angle-down' : 'fa fa-angle-right']"
                                v-if="childrenItem.children"></i>
                        </a>

                        <router-link class="lan-4" :class="{ 'active': childrenItem.active }" :to="childrenItem.path"
                            v-if="childrenItem.type == 'link'" @click="setNavActive(childrenItem, index)"
                            v-on:click="hidesecondmenu()">
                            {{ (childrenItem.title) }}
                            <label :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                                v-if="childrenItem.badgeType">{{ (childrenItem.badgeValue) }}</label>
                            <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
                        </router-link>

                        <a :href="childrenItem.path" v-if="childrenItem.type == 'extLink'" class="submenu-title">
                            {{ (childrenItem.title) }}
                            <label :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                                v-if="childrenItem.badgeType">{{ (childrenItem.badgeValue) }}</label>
                            <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
                        </a>

                        <a class="submenu-title" :href="childrenItem.path" target="_blank"
                            v-if="childrenItem.type == 'extTabLink'">
                            {{ (childrenItem.title) }}
                            <label :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                                v-if="childrenItem.badgeType">{{ (childrenItem.badgeValue) }}</label>
                            <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
                        </a>

                        <ul class="nav-sub-childmenu submenu-content" v-if="childrenItem.children"
                            :class="{ 'opensubchild': childrenItem.active }">
                            <li v-for="(childrenSubItem, index) in childrenItem.children" :key="index">

                                <router-link :class="{ 'active': childrenSubItem.active }" :to="childrenSubItem.path"
                                    v-if="childrenSubItem.type == 'link'" v-on:click="hidesecondmenu()"
                                    @click="setNavActive(childrenSubItem, index)">
                                    {{ (childrenSubItem.title) }}
                                    <label :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                                        v-if="childrenSubItem.badgeType">{{ (childrenSubItem.badgeValue) }}</label>
                                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                                </router-link>

                                <router-link :to="childrenSubItem.path" v-if="childrenSubItem.type == 'extLink'">
                                    {{ (childrenSubItem.title) }}
                                    <label :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                                        v-if="childrenSubItem.badgeType">{{ (childrenSubItem.badgeValue) }}</label>
                                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                                </router-link>

                                <router-link :to="childrenSubItem.path" v-if="childrenSubItem.type == 'extLink'">
                                    {{ (childrenSubItem.title) }}
                                    <label :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                                        v-if="childrenSubItem.badgeType">{{ (childrenSubItem.badgeValue) }}</label>
                                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>

        </ul>

        <div class="sidebar-bottom-stack">
            <div v-if="canRenewNow" class="sidebar-plan-cta">
                <div class="sidebar-plan-title">{{ sidebarPlanTitle }}</div>
                <small class="sidebar-plan-subtitle">{{ sidebarPlanSubtitle }}</small>
                <button
                    type="button"
                    class="sidebar-plan-btn"
                    @click="goToSubscriptionRenewal"
                >
                    Renovar Ahora
                </button>
            </div>

            <router-link
                v-if="isAdminUser"
                to="/tuscfdis-ia"
                class="sidebar-plan-btn sidebar-admin-btn"
                @click="hidesecondmenu"
            >
                TusCFDIs IA
            </router-link>

            <router-link
                v-if="isAdminUser"
                to="/administracion"
                class="sidebar-plan-btn sidebar-admin-btn"
                @click="hidesecondmenu"
            >
                Módulo de Administración
            </router-link>

            <router-link
                v-if="canViewDownloadMonitoringModule"
                to="/monitoreo-descargas"
                class="sidebar-plan-btn sidebar-admin-btn"
                @click="hidesecondmenu"
            >
                Módulo de Descargas
            </router-link>
        </div>
    </div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    layoutClasses
} from '../../constants/layout';
import accountService from '@/services/account';

export default {
    name: 'Navmenu',
    data() {
        return {
            layoutobj: {},
            items: [],
            text: '',
            active: false,
            user: {},
            subscription: null,
        };
    },
    computed: {
        ...mapState({
            menuItems: state => state.menu.data,
            layout: state => state.layout.layout,
            sidebar: state => state.layout.sidebarType,
            activeoverlay: (state) => state.menu.activeoverlay,
            togglesidebar: (state) => state.menu.togglesidebar,
            width: (state) => state.menu.width,
            height: (state) => state.menu.height,
            margin: (state) => state.menu.margin,
            menuWidth: (state) => state.menu.menuWidth,
        }),
        showPinTitle: {
            get() {
                let show = false;
                this.menuItems.every(item => {
                    item.showPin && (show = true)
                    return !show
                })
                return show
            }
        },
        sidebarUserName() {
            const userName = String(this.user && this.user.name ? this.user.name : '').trim();

            if (!userName) {
                return '';
            }

            if (userName.length > 18 && userName.includes(' ')) {
                return userName.split(' ')[0] + ' ' + userName.split(' ')[1];
            }

            return userName;
        },
        sidebarUserEmail() {
            return String(this.user && this.user.email ? this.user.email : '').trim();
        },
        isAdminUser() {
            return Boolean(this.user && this.user.is_admin);
        },
        canViewDownloadMonitoringModule() {
            if (!this.isAdminUser) {
                return false;
            }

            const email = String(this.user && this.user.email ? this.user.email : '').trim().toLowerCase();
            return email === 'raalveco@gmail.com';
        },
        subscriptionStatus() {
            return this.subscription?.status || null;
        },
        sidebarPlanTitle() {
            return this.subscription?.current_package?.name || 'Sin paquete';
        },
        sidebarPlanSubtitle() {
            const status = this.subscriptionStatus;

            if (!status) {
                return 'Sin información de vigencia';
            }

            if (status.is_expired) {
                return 'Tu suscripción está vencida';
            }

            const days = Number(status.days_remaining ?? 0);
            return `Tu suscripción expira en ${days} día${days !== 1 ? 's' : ''}`;
        },
        canRenewNow() {
            const status = this.subscriptionStatus;
            if (!status) {
                return false;
            }

            if (Boolean(status.is_expired)) {
                return true;
            }

            const days = Number(status.days_remaining ?? 9999);
            return Boolean(status.has_active_period) && days <= 15;
        },
        layoutobject: {
            get: function () {
                return JSON.parse(JSON.stringify(layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout)))[this.layout.settings.layout];
            },
            set: function () {
                this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
                this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
                return this.layoutobj;
            }
        },
    },
    watch: {
        '$route'() {
            this.loadSubscriptionData();
        },
        width() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
            window.addEventListener('scroll', this.handleScroll);
            this.handleScroll();
            if (window.innerWidth < 992) {
                const newlayout = JSON.parse(JSON.stringify(this.layoutobject).replace('horizontal-wrapper', 'compact-wrapper'));
                document.querySelector('.page-wrapper').className = 'page-wrapper ' + newlayout;
                this.$store.state.menu.margin = 0;
            } else {
                document.querySelector('.page-wrapper').className = 'page-wrapper ' + this.layoutobject;
            }

            if ((window.innerWidth < 1199 && this.layout.settings.layout === 'Tokyo') || (window.innerWidth < 1199 && this.layout.settings.layout === 'Moscow') || (window.innerWidth < 1199 && this.layout.settings.layout === 'Rome')) {
                this.menuItems.filter(menuItem => {
                    menuItem.active = false;
                });
            }
        }

    },
    created() {

        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        if (this.$store.state.menu.width < 991) {
            this.layout.settings.layout = 'Dubai';
            this.margin = 0;
        }
        setTimeout(() => {
            const elmnt = document.getElementById('myDIV');

            if(elmnt != null){
                this.$store.state.menu.menuWidth = elmnt.offsetWidth;
                this.$store.state.menu.menuWidth > window.innerWidth ?
                    (this.$store.state.menu.hideRightArrow = false, this.$store.state.menu.hideLeftArrowRTL = false) :
                    (this.$store.state.menu.hideRightArrow = false, this.$store.state.menu.hideLeftArrowRTL = true);
            }
        }, 500);
        this.layoutobject = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
        this.layoutobject = JSON.parse(JSON.stringify(this.layoutobject))[this.layout.settings.layout];

    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {

        this.loadSidebarUserInfo();
        this.loadSubscriptionData();

        window.addEventListener('unload', this.HandleUnload)
        let LocalPins = JSON.parse(localStorage.getItem('pins') || '[]')
        LocalPins.forEach(pin => {
            let pinIndex = this.menuItems.findIndex(menu => menu.title == pin);
            pinIndex > -1 && (this.menuItems[pinIndex].showPin = true)
        })
        this.menuItems.filter(items => {
            if (items.path === this.$route.path)
                this.$store.dispatch('menu/setActiveRoute', items);
            if (!items.children) return false;
            items.children.filter(subItems => {
                if (subItems.path === this.$route.path)
                    this.$store.dispatch('menu/setActiveRoute', subItems);
                if (!subItems.children) return false;
                subItems.children.filter(subSubItems => {
                    if (subSubItems.path === this.$route.path)
                        this.$store.dispatch('menu/setActiveRoute', subSubItems);
                });
            });
        });

    },
    methods: {
        async loadSubscriptionData() {
            try {
                const response = await accountService.getSubscription();
                this.subscription = response?.type === 'success' ? (response?.data || null) : null;
            } catch (error) {
                this.subscription = null;
            }
        },
        goToSubscriptionRenewal() {
            if (!this.canRenewNow) {
                return;
            }

            this.$router.push({
                name: 'settings',
                query: {
                    section: 'subscription',
                },
            });
        },
        HandleUnload() {
            let pinsArray = [];
            this.menuItems.forEach(item => {
                item.showPin && pinsArray.push(item.title);
            })
            localStorage.setItem('pins', JSON.stringify(pinsArray))
        },
        loadSidebarUserInfo() {
            const rawUser = localStorage.getItem('user');

            if (!rawUser || rawUser === 'undefined') {
                this.user = {};
                return;
            }

            try {
                this.user = JSON.parse(rawUser) || {};
            } catch (error) {
                this.user = {};
            }
        },
        handleScroll() {
            if (window.scrollY > 400) {
                if (this.layoutobject.split(' ').pop() === 'material-type' || this.layoutobject.split(' ').pop() === 'advance-layout')
                    document.querySelector('.sidebar-main').className = 'sidebar-main hovered';
            } else {
                if (document.getElementById('sidebar-main'))
                    document.querySelector('.sidebar-main').className = 'sidebar-main';
            }
        },
        togglePinnedName({ item }) {
            item.showPin = !item.showPin
            // this.active = !this.active
            if (this.menuItems.length > 0) {
                this.menuItems = ''
            } else {
                this.menuItems = ''
            }
        },
        setNavActive(item) {
            this.$store.dispatch('menu/setNavActive', item);
            if (this.layoutobject.split(' ').includes('compact-sidebar') && window.innerWidth > 991) {
                if (this.menuItems.some(menuItem => menuItem.active === true)) {
                    this.$store.state.menu.activeoverlay = true;
                } else {
                    this.$store.state.menu.activeoverlay = false;
                }
            }
        },

        setNavActiveh(item) {
            if (this.layoutobject.split(' ').includes('horizontal-wrapper')) {
                this.$store.dispatch('menu/setNavActive', item);
                if (this.layoutobject.split(' ').includes('compact-sidebar') && window.innerWidth > 991) {
                    if (this.menuItems.some(menuItem => menuItem.active === true)) {
                        this.$store.state.menu.activeoverlay = true;
                    } else {
                        this.$store.state.menu.activeoverlay = false;
                    }
                }
            }

        },
        hidesecondmenu() {
            if (window.innerWidth < 991) {
                this.$store.state.menu.activeoverlay = false,
                    this.$store.state.menu.togglesidebar = false;
                this.menuItems.filter(menuItem => {
                    menuItem.active = false;
                });
            } else if (this.layoutobject.split(' ').includes('compact-sidebar')) {
                this.$store.state.menu.activeoverlay = false,
                    this.menuItems.filter(menuItem => {
                        menuItem.active = false;
                    });
            }
        },
        handleResize() {
            this.$store.state.menu.width = window.innerWidth - 450;
        },
    },
    beforeDestroy() {
    }
};
</script>

<style scoped>
#sidebar-menu {
    position: relative;
    height: 100%;
}

#sidebar-menu .sidebar-links {
    padding-top: 16px;
    padding-bottom: 230px;
}

#sidebar-menu .sidebar-links > li.sidebar-main-title > div h6,
#sidebar-menu .sidebar-links > li.sidebar-main-title > h6 {
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    opacity: 0.65;
    margin-bottom: 4px;
}

#sidebar-menu .sidebar-links > li.sidebar-list > .sidebar-link {
    margin: 2px 10px;
    border-radius: 8px;
    transition: background-color 0.16s ease, color 0.16s ease;
}

#sidebar-menu .sidebar-links > li.sidebar-list > .sidebar-link .stroke-icon,
#sidebar-menu .sidebar-links > li.sidebar-list > .sidebar-link .fill-icon {
    transition: color 0.16s ease, stroke 0.16s ease;
}

#sidebar-menu .sidebar-links > li.sidebar-list > .sidebar-link span {
    font-weight: 500;
}

#sidebar-menu .sidebar-links > li.sidebar-list > .sidebar-link:hover {
    background-color: var(--sidebar-border);
}

#sidebar-menu .sidebar-links > li.sidebar-list > .sidebar-link:hover .stroke-icon {
    stroke: var(--theme-deafult);
}

#sidebar-menu .sidebar-links > li.sidebar-list > .sidebar-link.active {
    background-color: var(--sidebar-border);
    position: relative;
}

#sidebar-menu .sidebar-links > li.sidebar-list > .sidebar-link.active::before {
    content: "";
    position: absolute;
    left: 0;
    top: 8px;
    bottom: 8px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background-color: var(--theme-deafult);
}

#sidebar-menu .sidebar-links > li.sidebar-list > .sidebar-link::after {
    content: none !important;
}

#sidebar-menu .sidebar-links .sidebar-submenu {
    margin-top: 2px;
}

#sidebar-menu .sidebar-links .sidebar-submenu > li > a,
#sidebar-menu .sidebar-links .sidebar-submenu > li > .lan-4,
#sidebar-menu .sidebar-links .sidebar-submenu > li > .submenu-title,
#sidebar-menu .sidebar-links .sidebar-submenu > li > .router-link-active {
    border-radius: 8px;
    margin: 1px 12px;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    transition: all 0.16s ease;
}

#sidebar-menu .sidebar-links .sidebar-submenu > li > a:hover,
#sidebar-menu .sidebar-links .sidebar-submenu > li > .lan-4:hover,
#sidebar-menu .sidebar-links .sidebar-submenu > li > .submenu-title:hover,
#sidebar-menu .sidebar-links .sidebar-submenu > li > .router-link-active:hover {
    background-color: var(--sidebar-border);
}

#sidebar-menu .sidebar-bottom-stack {
    position: absolute;
    bottom: 37px;
    left: 0;
    right: 0;
    padding: 0 10px;
    z-index: 3;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

#sidebar-menu .sidebar-plan-cta {
    display: block;
    border-radius: 12px;
    padding: 16px;
    text-decoration: none;
    background: linear-gradient(110deg, var(--theme-secondary) 0%, var(--theme-deafult) 72%);
    box-shadow: 0 8px 18px var(--sidebar-border);
}

#sidebar-menu .sidebar-plan-title {
    color: var(--white);
    font-size: 13px;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 2px;
}

#sidebar-menu .sidebar-plan-subtitle {
    display: block;
    color: var(--white);
    opacity: 0.85;
    font-size: 11px;
    margin-bottom: 8px;
}

#sidebar-menu .sidebar-plan-btn {
    display: block;
    width: 100%;
    border: 0;
    cursor: pointer;
    text-align: center;
    font-size: 11px;
    font-weight: 600;
    color: var(--white);
    padding: 7px 8px;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.24);
}

#sidebar-menu .sidebar-admin-btn {
    margin-top: 10px;
    text-align: center;
    text-decoration: none;
    background: var(--theme-deafult);
    color: var(--white);
    border: 1px solid var(--theme-deafult);
}

#sidebar-menu .sidebar-admin-btn:hover {
    background: var(--theme-secondary);
    border-color: var(--theme-secondary);
    color: var(--white);
}

#sidebar-menu .sidebar-user-footer {
    padding: 0;
}

#sidebar-menu .sidebar-user-link {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: var(--white);
    border: 1px solid var(--sidebar-border);
    border-radius: 10px;
    box-shadow: 0 2px 8px var(--sidebar-border);
    text-decoration: none;
    color: inherit;
    overflow: hidden;
}

#sidebar-menu .sidebar-user-info {
    flex: 1;
    min-width: 0;
}

#sidebar-menu .sidebar-user-info strong {
    display: block;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.2;
    color: var(--theme-font-color);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#sidebar-menu .sidebar-user-info small {
    display: block;
    font-size: 12px;
    line-height: 1.2;
    color: var(--theme-font-color);
    opacity: 0.7;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#sidebar-menu .sidebar-user-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-right: 20px;
}

#sidebar-menu .sidebar-action-btn {
    border: 0;
    background: var(--white);
    padding: 4px;
    text-decoration: none;
    cursor: pointer;
    border-radius: 6px;
    border: 1px solid var(--sidebar-border);
    transition: all 0.15s ease;
}

#sidebar-menu .sidebar-action-btn i {
    font-size: 16px;
    color: var(--theme-font-color);
    opacity: 0.8;
}

#sidebar-menu .sidebar-action-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px var(--sidebar-border);
}

#sidebar-menu .sidebar-action-btn:hover i {
    color: var(--theme-deafult);
    opacity: 1;
}

</style>
